module.exports = __webpack_public_path__ + "static/screenshot-iphone12-two-65595f9a5b025ed05aa8d6a055fd314b.png";